import { BRAND_INK, BRAND_SIGNAL } from '../../brand/constants'
import XosaSunIcon from './XosaSunIcon'

type XosaWordmarkProps = {
  className?: string
  iconClassName?: string
  textClassName?: string
}

/**
 * Header wordmark — striped sun + “xosa” (ink) + “origin” (signal).
 */
const XosaWordmark: React.FC<XosaWordmarkProps> = ({
  className = 'inline-flex items-center gap-2.5 font-sans text-xl font-light tracking-wide',
  iconClassName = 'h-9 w-9 shrink-0',
  textClassName,
}) => (
  <span className={className}>
    <XosaSunIcon className={iconClassName} />
    <span className={textClassName}>
      <span style={{ color: BRAND_INK }}>xosa</span>
      <span style={{ color: BRAND_SIGNAL }}>origin</span>
    </span>
  </span>
)

export default XosaWordmark
